import { connect } from 'react-redux'
import * as selector from '../../state/quotation/selector'
import * as treatmentPlanSelector from '../../state/plan/selector'
import TreatmentVisualizationWidget from './TreatmentVisualizationWidget'


const mapStateToProps = (state, props) => {
    return {
        treatmentQuotation: selector.selectTreatmentQuotation(state),
        treatmentPlan: treatmentPlanSelector.selectTreatmentPlan(state),
    }
}

const mapDispatchToProps = {}


export default connect(mapStateToProps, mapDispatchToProps)(TreatmentVisualizationWidget)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/TreatmentVisualizationWidgetContainer.js